import { concat, EMPTY, Observable, of } from "rxjs";
import { catchError, concatMap, map, mergeMap } from "rxjs/operators";
import { PayrollFileApi } from "../api/payroll-file-api";
import { TypeRates } from "../constants/enums/quotation";
import {
    catchErrorWithDispatch,
    handleApiError,
    isTokenExpiredError,
} from "../libs/utils/errors";
import { PayrollFileActions } from "../redux/payroll-file/actions";
import {
    GetPayrollFileProcess,
    GetPayrollFileProcessDone,
    PayrollFileDownloadTemplateFileDone,
    PayrollFileUpload,
    PayrollFileUploadDone,
    ShowPayrollFileErrorModal,
} from "../redux/payroll-file/actions/default";
import {
    QuotationCalculate,
    QuotationIsValid,
} from "../redux/quotation/actions/default";
import { ZohoPhaseFile } from "../redux/zoho/actions/default";

export class PayrollFileRepository {
    static downloadPayrollFileTemplate(): Observable<PayrollFileActions> {
        return PayrollFileApi.downloadPayrollFileApi().pipe(
            map(({ response }) =>
                new PayrollFileDownloadTemplateFileDone(response).create()
            ),
            catchErrorWithDispatch((err) =>
                of(new PayrollFileDownloadTemplateFileDone(err).create())
            )
        );
    }

    static uploadPayrollFile(
        action: PayrollFileUpload
    ): Observable<PayrollFileActions> {
        const fileName = `${action.payload.now || Date.now()}-${
            action.payload.fileName
        }`;

        const body = {
            ...action.payload,
            fileName,
        };

        return PayrollFileApi.uploadPayrollFileApi(body).pipe(
            concatMap(({ response }) =>
                concat(
                    of(new PayrollFileUploadDone(response).create()),
                    of(
                        new GetPayrollFileProcess({
                            fileName,
                        }).create()
                    ),
                    of(
                        new ZohoPhaseFile({
                            fileContent: action.payload.fileContent,
                            fileName: fileName,
                        }).create()
                    )
                )
            ),
            catchError((err) => {
                if (isTokenExpiredError(err)) {
                    handleApiError(err);
                    return EMPTY;
                }
                return concat(
                    of(new PayrollFileUploadDone(err).create()),
                    of(new QuotationIsValid(err).create()),
                    of(new ShowPayrollFileErrorModal(err).create())
                );
            })
        );
    }

    static getPayrollFileProcess(
        action: GetPayrollFileProcess
    ): Observable<PayrollFileActions> {
        return PayrollFileApi.getPayrollFileProcess(action.payload).pipe(
            mergeMap(({ response }) =>
                concat(
                    of(new GetPayrollFileProcessDone(response).create()),
                    of(
                        new QuotationCalculate({
                            ...action.payload,
                            typeRate: TypeRates.ANNUAL,
                        }).create()
                    ),
                    of(
                        new QuotationCalculate({
                            ...action.payload,
                            typeRate: TypeRates.SEMESTER,
                        }).create()
                    )
                )
            ),
            catchError((err) =>
                concat(
                    of(new GetPayrollFileProcessDone(err).create()),
                    of(new QuotationIsValid(err).create()),
                    of(new ShowPayrollFileErrorModal(err).create())
                )
            )
        );
    }
}
